// Query key factory for companies
export const companyKeys = {
  all: ['companies'] as const,

  lists: () => [...companyKeys.all, 'list'] as const,
  list: (filters: Record<string, any> = {}) => [...companyKeys.lists(), filters] as const,

  details: () => [...companyKeys.all, 'detail'] as const,
  detail: (id: string) => [...companyKeys.details(), id] as const,

  userCompanies: (userId: string) => [...companyKeys.all, 'user', userId] as const,
  userJoinedCompanies: (userId: string) => [...companyKeys.all, 'user', userId, 'joined'] as const,

  companyUsers: (companyId: string) => [...companyKeys.all, 'users', companyId] as const,

  byIds: (ids: string[]) => [...companyKeys.all, 'byIds', ids.sort()] as const,

  invitation: (token: string) => [...companyKeys.all, 'invitation', token] as const,
} as const

export const {
  all: allCompaniesKey,
  lists: companiesListsKey,
  list: companiesListKey,
  details: companiesDetailsKey,
  detail: companyDetailKey,
  userCompanies: userCompaniesKey,
  userJoinedCompanies: userJoinedCompaniesKey,
  companyUsers: companyUsersKey,
  byIds: companiesByIdsKey,
  invitation: companyInvitationKey,
} = companyKeys
